<script>
  import { onMount } from 'svelte';
  import { readable } from 'svelte/store';
  import { locale } from 'svelte-i18n';
  import { formatDistanceToNow } from 'date-fns';
  import { es } from 'date-fns/locale';

  /**
   * Date to format
   * @type {Date}
   * @default new Date()
   */
  export let date = new Date();

  /**
   * Update interval in seconds.
   * @type {number}
   * @default 60
   */
  export let updateSeconds = 60;

  let timeAgo;

  const format = (date) => {
    // TODO consider adding to date.js utils:
    return formatDistanceToNow(date, {
      addSuffix: true,
      locale: $locale === 'es' ? es : undefined
    });
  };

  const timeAgoStore = readable('', (set) => {
    const update = () => set(format(date));

    const interval = setInterval(update, updateSeconds * 1000);

    update();

    return () => clearInterval(interval);
  });

  $: timeAgo = $timeAgoStore;

  onMount(() => {
    timeAgo = format(date);
  });
</script>

<time {...$$restProps} datetime={date.toISOString()}>{timeAgo}</time>
